import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";

import "nprogress/nprogress.css";

import App from "src/App";
import { AuthProvider } from "src/contexts/JWTAuthContext";
import { SidebarProvider } from "src/contexts/SidebarContext";
import ScrollTop from "src/hooks/useScrollTop";
import * as serviceWorker from "src/serviceWorker";
import store from "src/store";
import "src/utils/chart";

import { GlobalContextProvider } from "./contexts/GlobalContext";

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <GlobalContextProvider>
        <SidebarProvider>
          <HashRouter>
            <ScrollTop />
            <AuthProvider>
              <App />
            </AuthProvider>
          </HashRouter>
        </SidebarProvider>
      </GlobalContextProvider>
    </Provider>
  </HelmetProvider>,
  document.getElementById("root"),
);

serviceWorker.unregister();
